/**
 * 忘记密码前提：保证本机 OPS P-256 钥已登记（可匿名）。
 */

import { OPS_DEVICE_KEY_ALG, registerDevicePublicKey } from '../api/login';
import {
  buildOpsPopSignMessage,
  ensureOpsKey,
  isOpsPublicKeyRegistered,
  markOpsPublicKeyRegistered,
  signOps,
} from './opsDeviceKey';

const OPS_KEY_ID = 'v1';

let registerInflight: Promise<boolean> | null = null;

function resolveDeviceModel(): string {
  try {
    return navigator.userAgent?.slice(0, 120) || 'WEB';
  } catch {
    return 'WEB';
  }
}

/** 确保公钥已上报；失败返回 false（调用方可继续试 forgetPassword，视后端是否豁免 WEB） */
export async function ensureOpsPublicKeyRegistered(): Promise<boolean> {
  if (registerInflight) return registerInflight;

  registerInflight = (async () => {
    const { publicKey, deviceCode } = await ensureOpsKey();
    if (!deviceCode || !publicKey) return false;
    if (isOpsPublicKeyRegistered(deviceCode)) return true;

    const timestamp = Date.now();
    const opsPopSign = await signOps(buildOpsPopSignMessage(timestamp, deviceCode, publicKey));
    await registerDevicePublicKey({
      deviceCode,
      devicePublicKey: publicKey,
      keyId: OPS_KEY_ID,
      deviceModel: resolveDeviceModel(),
      opsPopSign,
      timestamp,
      keyAlg: OPS_DEVICE_KEY_ALG,
      signAlgo: OPS_DEVICE_KEY_ALG,
    });
    markOpsPublicKeyRegistered(deviceCode);
    return true;
  })()
    .catch((err) => {
      consoleWarnOps(err);
      return false;
    })
    .finally(() => {
      registerInflight = null;
    });

  return registerInflight;
}

function consoleWarnOps(err: unknown) {
  try {
    if (String(import.meta.env.VITE_MODE || '').includes('dev')) {
      console.warn('[opsKey] registerPublicKey failed', err);
    }
  } catch {
    /* ignore */
  }
}
